// frontend/shared-ui/src/forms/schemas/sfp.js
export default {
    slug: 'sfp',
    label: 'SFP / Transceivers',
    defaultUnit: 'pcs',
    costDefaults: {
        avgVolumeCbm: 0.00015,
        suggestedMarkupPct: 35,
        freightSensitivity: 'low',
        note: 'SFP modules ship in bulk 10-packs',
    },
    groups: [
        {
            id: 'basic',
            label: 'Basic',
            columns: 3,
            fields: [
                {
                    key: 'formFactor', label: 'Form Factor', type: 'select', required: true,
                    options: ['SFP', 'SFP+', 'SFP28', 'QSFP+', 'QSFP28', 'QSFP-DD', 'XFP', 'CFP']
                },
                {
                    key: 'rate', label: 'Rate', type: 'select', required: true,
                    options: ['100M', '1G', '10G', '25G', '40G', '100G', '200G', '400G']
                },
                {
                    key: 'distance', label: 'Reach', type: 'text', required: true,
                    placeholder: '10km', hint: 'e.g. 100m, 10km, 40km'
                },
            ],
        },
        {
            id: 'optical',
            label: 'Optical',
            columns: 3,
            fields: [
                { key: 'wavelength', label: 'Wavelength', type: 'number', required: true, unit: 'nm' },
                {
                    key: 'connectorType', label: 'Connector', type: 'select',
                    options: ['LC', 'SC', 'MPO', 'MTP', 'RJ45']
                },
                {
                    key: 'fiberMode', label: 'Fiber Mode', type: 'select',
                    options: ['SM', 'MM']
                },
            ],
        },
        {
            id: 'power',
            label: 'Power & Sensitivity',
            columns: 3,
            fields: [
                { key: 'txPower', label: 'TX Power', type: 'text', placeholder: '-9 ~ -3 dBm' },
                { key: 'rxSensitivity', label: 'RX Sensitivity', type: 'text', placeholder: '-22 dBm' },
                { key: 'budget', label: 'Optical Budget', type: 'number', unit: 'dB' },
                { key: 'temperature', label: 'Operating Temp', type: 'text', placeholder: '0 to 70 °C' },
                { key: 'ddm', label: 'Digital Diagnostics (DDM)', type: 'boolean' },
            ],
        },
    ],

    buildSku(v) {
        const parts = [
            'SFP',
            v.formFactor || '',
            v.rate || '',
            v.wavelength ? `${v.wavelength}NM` : '',
            v.distance ? String(v.distance).toUpperCase().replace(/\s+/g, '') : '',
            v.connectorType || '',
            v.fiberMode || '',
        ];
        return parts.filter(Boolean).join('-').toUpperCase().replace(/\s+/g, '');
    },

    buildName(v) {
        const bits = [];
        if (v.rate) bits.push(v.rate);
        if (v.formFactor) bits.push(v.formFactor);
        if (v.wavelength) bits.push(`${v.wavelength}nm`);
        if (v.distance) bits.push(`${v.distance} reach`);
        if (v.connectorType) bits.push(v.connectorType);
        if (v.fiberMode) bits.push(v.fiberMode);
        bits.push('Optical Transceiver');
        return bits.join(' ');
    },

    attributeSchema: [
        { key: 'formFactor', label: 'Form Factor' },
        { key: 'rate', label: 'Rate' },
        { key: 'distance', label: 'Reach' },
        { key: 'wavelength', label: 'Wavelength', unit: 'nm' },
        { key: 'connectorType', label: 'Connector' },
        { key: 'fiberMode', label: 'Fiber Mode' },
        { key: 'txPower', label: 'TX Power' },
        { key: 'rxSensitivity', label: 'RX Sensitivity' },
        { key: 'budget', label: 'Optical Budget', unit: 'dB' },
        { key: 'temperature', label: 'Operating Temp' },
        { key: 'ddm', label: 'Digital Diagnostics (DDM)' },
    ],
};